import { SearchEstabilishment } from '../../apis/estabilishment/SearchEstabilishment';

export const EstabilishmentService = {
  search: async () => {
    return await SearchEstabilishment();
  },
};
